const storefrontAccessToken = 'c9d7dcd43c1388da58e094c9de56ac3d'; // Replace with your token
const shopDomain = 'spellbinders-paper-arts.myshopify.com'; // Replace with your shop domain
let endCursor = null;
let hasNextPage = true;
$(function(){
    jQuery('#loginLink').on('click',function(e){
        e.preventDefault();
        var email = $('#email').val();
        var password = $('#password').val();
        createCustomerAccessToken(email, password);
    });
    
    if($('#orderTableData').length){
      generateOrderTable();
      document.getElementById('loadMoreBtn').addEventListener('click', () => {
        if (hasNextPage) {
          generateOrderTable();
        } else {
          $('#loadMoreBtn').after('<span>No more orders found.</span>');
        }
      });
    }
});
async function generateOrderTable() {
    const accessToken = localStorage.getItem("accessToken");
    
  const query = `
  {
    customer(customerAccessToken: "${accessToken}") {
      orders(first: 10${endCursor ? `, after: "${endCursor}"` : ''}) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            name
            processedAt
            customerUrl
            financialStatus
            fulfillmentStatus
            canceledAt
            totalPrice {
              amount
              currencyCode
            }
            lineItems(first: 5) {
              edges {
                node {
                  title
                  quantity
                }
              }
            }
          }
        }
      }
    }
  }
`;

fetch(`https://${shopDomain}/api/2023-04/graphql.json`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
  },
  body: JSON.stringify({ query })
})
  .then(res => res.json())
  .then(data => {
    const orders = data.data.customer.orders;
    const edges = orders.edges;

    const tbody = document.querySelector('#orderTableData'); // You need this in HTML

    edges.forEach(edge => {
      const order = edge.node;
      // console.log(`Order: ${order.name} — $${order.totalPrice.amount}`);
      // order.lineItems.edges.forEach(item => {
      //   console.log(`  - ${item.node.quantity}x ${item.node.title}`);
      // });
      const tr = document.createElement('tr');
      tr.className = '';
      var cancelClass = order.canceledAt != null ? 'cancelled_order':'';
      tr.innerHTML = `
        <td class="account-order-number first ${cancelClass}" data-title="Order">
          <a href="${order.customerUrl || '#'}">${order.name}</a>
          <span class="date"> - ${new Date(order.processedAt).toLocaleDateString()}</span>
        </td>
        <td class="account-order-payment-status ${order.financialStatus}" data-title="Payment">
          ${order.financialStatus}
        </td>
        <td class="account-order-fulfillment-status ${order.fulfillmentStatus}" data-title="Fulfillment">
          ${order.fulfillmentStatus}
        </td>
        <td class="account-order-total last" data-title="Total">
          <span class="money">$${order.totalPrice.amount}</span>
        </td>
      `;

      tbody.appendChild(tr);
      
    });

    hasNextPage = orders.pageInfo.hasNextPage;
    endCursor = orders.pageInfo.endCursor;
    if (!hasNextPage) {
      $('#loadMoreBtn').after('<span>No more orders found.</span>');
      $('#loadMoreBtn').hide();
    }
  })
  .catch(err => console.error(err));
}

async function createCustomerAccessToken(email, password) {
     const query = `
       mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
          customerAccessTokenCreate(input: $input) {
            customerAccessToken {
              accessToken
              expiresAt
            }
            userErrors {
              field
              message
            }
          }
        }
    `;
  
    const variables = {
      input: {
        email: email,
        password: password
      }
    };
  
    const response = await fetch(`https://${shopDomain}/api/2024-01/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken
      },
      body: JSON.stringify({ query, variables })
    });
  
    const data = await response.json();
  
    if (data.errors) {
      console.error('GraphQL errors:', data.errors);
    } else if (data.data.customerAccessTokenCreate.userErrors.length > 0) {
      console.error('User errors:', data.data.customerAccessTokenCreate);
    }else{
      localStorage.setItem("accessToken", data.data.customerAccessTokenCreate.customerAccessToken.accessToken);
      $('#btnLogin').click();
    }
}